import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import Section from '../components/ui/Section';
import PathwaySection from '../components/home/PathwaySection';
import Button from '../components/ui/Button';

const StartHere = () => {
  const discoveryLink = "https://tidycal.com/1x8odpm/ai-discovery-call-1y6rlrd";

  return (
    <MainLayout>
      <Section bg="white" className="pt-20 pb-12">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-brand-navy mb-6">Start where you are.</h1>
          <p className="text-xl text-gray-600">
            You do not need to know all the tools. You need to know your next responsible leadership step.
            Choose the statement that best describes your organisation right now.
          </p>
        </div>
      </Section>

      <div className="pb-24 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-6">
            {/* AI Discovery Call */}
            <div className="bg-brand-teal/5 rounded-2xl p-8 md:p-10 border border-brand-teal/20 flex flex-col md:flex-row gap-8 items-center justify-between">
              <div>
                <h3 className="text-2xl font-bold text-brand-navy mb-2">"I need a quick pulse check"</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  A free 20-minute discovery conversation to understand where your organisation is today, 
                  where you want to be, and what support may help you lead with confidence.
                </p>
              </div>
              <Button href={discoveryLink} variant="primary" className="whitespace-nowrap">
                Book Discovery Call
              </Button>
            </div>

            {/* AI Confidence Training */}
            <div className="bg-brand-cream rounded-2xl p-8 md:p-10 border border-gray-200 flex flex-col md:flex-row gap-8 items-center justify-between">
              <div>
                <h3 className="text-2xl font-bold text-brand-navy mb-2">"We need staff confidence"</h3>
                <p className="text-gray-600 mb-4">You want your team to stop feeling overwhelmed and start feeling capable.</p>
              </div>
              <Button to="/work-with-us" variant="outline" className="whitespace-nowrap bg-white">
                View AI Confidence Training
              </Button>
            </div>

            {/* AI Leadership Sprint */}
            <div className="bg-white rounded-2xl p-8 md:p-10 border-2 border-brand-navy flex flex-col md:flex-row gap-8 items-center justify-between shadow-sm">
              <div>
                <h3 className="text-2xl font-bold text-brand-navy mb-2">"We are ready to lead AI properly"</h3>
                <p className="text-gray-600 mb-4">You want structured, strategic support to lead AI safely across the organisation.</p>
              </div>
              <Button to="/contact" variant="secondary" className="whitespace-nowrap">
                Enquire About AI Leadership Sprint
              </Button>
            </div>
          </div>
        </div>
      </div>
      
      <PathwaySection />
    </MainLayout>
  );
};

export default StartHere;